// extracted by mini-css-extract-plugin
module.exports = {"outOfStockMessage":"ShipFromStoreESI_outOfStockMessage__CxDKv"};